var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "text-bold" }, [
      _vm._v(_vm._s(_vm._.get(_vm.asset, "name")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "small-link" }, [
      _vm._v(_vm._s(_vm.path.replace(/\//g, "/")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ae4d17f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae4d17f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/AssetInfoComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6ae4d17f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/AssetInfoComponent.vue
// module chunks = 0